export enum CatalogName {
  ACTIVE_SUBSTANCES = 'active-substances',
  ACTIVITY_KINDS = 'supervised-object-activity-types',
  ADVERSE_REACTION_TYPES = 'adverse-reaction-types',
  ANIMAL_SPECIES = 'animal-species',
  DRUG_ADMINISTRATION_WAYS = 'drug-administration-ways',
  FEED_ADDITIVE_KINDS = 'feed-additive-kinds',
  FEED_ADDITIVE_TYPES = 'feed-additive-types',
  GMO_RESEARCH_TYPES = 'gmo-research-types',
  GMO_USE_TYPES = 'gmo-use-types',
  INFORMATION_SOURCE = 'information-source',
  MANUAL_CHANGES_TYPES = 'manual-changes-types',
  PHARM_GROUPS = 'pharm-groups',
  PHARM_PACKAGE_TYPES = 'pharm-package-types',
  PHARM_RELEASE_FORMS = 'pharm-release-forms',
  SIGNING_PERSON = 'signing-person',
  SYMPTOMS = 'symptoms',
  UNITS = 'units',
  MEASURING_UNITS = 'measuring-units',
}

export type FindFnParams<F, S> = {
  filter: F | null;
  sorting: S | null;
};

export type EditType<T> = T & {
  id?: string;
};

export type DefaultFilterSorting = {
  code?: string;
  name?: string;
  description?: string;
};
